/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: Liu ShuaiBo
 * @LastEditTime: 2021-10-26 15:09:29
 */
import ColumnTypes from "@/utils/ColumnTypes";
const file_name = {
    key: 'file_name',
    label: '文件名称',
    type: ColumnTypes.TextCell,
    fixed: 'left',
    minWidth: '100',
};
const add_time = {
    key: 'add_time',
    label: '操作时间',
    type: ColumnTypes.TextCell,
    minWidth: '100',
}
const opt_name = {
    key: 'opt_name',
    label: '操作人',
    type: ColumnTypes.TextCell,
    minWidth: '100',
}
const export_status = {
    key: 'export_status',
    label: '状态',
    type: ColumnTypes.exportStateCell,
    minWidth: '100',
}
const expire_status = {
    key: 'expire_status',
    label: '操作',
    type: ColumnTypes.downloadCell,
    minWidth: '100',
    fixed: 'right',
    align: 'right'
}

export const columns = [
    file_name,
    add_time,
    opt_name,
    export_status,
    expire_status
]